export const homepageHeadingKeys = ['text2247', 'text2248', 'text2249'] as const;

export function resolveHomepageTitle(
  authoredTitle: string | null | undefined,
  translate: (key: string) => string,
): string | undefined {
  const title = authoredTitle?.replace(/\s+/g, ' ').trim();
  if (title && !/^(domov|home)$/i.test(title)) return title;

  const lines = homepageHeadingKeys.map(key => translate(key)?.replace(/\s+/g, ' ').trim());
  if (lines.some((line, index) => !line || line === homepageHeadingKeys[index])) return undefined;
  return lines.join(' ');
}
